export const onlineHBookingColumns = [
    { Header: 'Sl. No.', accessor: 'Sl' },
    { Header: 'Property Name', accessor: 'PropertyName' },
    { Header: 'Customer Name', accessor: 'CustomerName' },
    { Header: 'Booking Date & Time', accessor: 'BillDate' },
    { Header: 'Check-In Date', accessor: 'CheckinDate' },
    { Header: 'Check-Out Date', accessor: 'CheckOutDate' },
    { Header: 'Booking Ref No', accessor: 'BookingRefNo' },
    { Header: 'Rooms Booked', accessor: 'TotalNoOfRoom' },
    { Header: 'Payment Mode', accessor: 'PaymentMode' },
    { Header: 'Total Amount', accessor: 'TotalAmount' },
    { Header: 'Bank Txn No', accessor: 'ChequeDDNo' },
    { Header: 'Transaction Date', accessor: 'IssueDate' }
  ];